import type { EpisodeAvailability, RoomQueueItemView } from '@anisync/types';

/**
 * Reguły kolejki pokoju, wyjęte z komponentów.
 *
 * Obie odpowiadają na pytanie „czy ten przycisk ma coś zrobić", a to jest
 * dokładnie ten rodzaj warunku, który wpisany w JSX nigdy nie dostaje testu
 * i cicho przestaje działać przy pierwszej zmianie kształtu danych.
 */

/**
 * Czy odcinek da się zakolejkować.
 *
 * Siatka odcinków dostaje z serwera także numery **dopisane** do deklarowanej
 * długości serii — luki w wydaniach poznaje się właśnie po pustej liście źródeł.
 * Zakolejkowanie takiej pozycji kończy się tabelą nieudanych prób i wpisem,
 * którego pokój nigdy nie odtworzy.
 *
 * Materiał leżący na dysku wystarcza SAM: odcinek pobrany, a potem zdjęty ze
 * źródła, nadal da się obejrzeć i nie ma powodu go blokować.
 */
export function isEpisodeQueueable(episode: EpisodeAvailability): boolean {
  return episode.sources.length > 0 || episode.mediaFileId !== null;
}

/**
 * Numery odcinków TEJ serii stojące już w kolejce.
 *
 * Liczone z kolejki serwera, nie ze stanu lokalnego: pozycję mógł dołożyć ktoś
 * inny w pokoju, a wtedy własny stan komponentu nic o niej nie wie i przycisk
 * zapraszałby do zrobienia duplikatu.
 */
export function queuedEpisodesFor(
  queue: readonly RoomQueueItemView[],
  titleId: string | null,
): number[] {
  if (titleId === null) return [];
  return queue
    .filter((item) => item.titleId === titleId && item.episodeNumber !== null)
    .map((item) => item.episodeNumber as number);
}
